__turbopack_context__.v({
  "lds-ellipsis": "index-module__5HfA_G__lds-ellipsis",
  "lds-ellipsis1": "index-module__5HfA_G__lds-ellipsis1",
  "lds-ellipsis2": "index-module__5HfA_G__lds-ellipsis2",
  "lds-ellipsis3": "index-module__5HfA_G__lds-ellipsis3",
});
